import { ReportLine } from './report-line';
export class ReportLineList {
  count   !: number;
  next    !: string;
  previous!: string;
  results !: ReportLine[];

  constructor() {}
}
